/**
 * Environment Configuration - No fallbacks
 * Required vars must be set in .env.development or .env.production
 */

const getRaw = (key: string): string | undefined => {
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key] !== undefined) {
    return import.meta.env[key] as string;
  }
  return undefined;
};

/** Get required env var - throws if missing or empty. No fallback. */
export const getEnvVar = (key: string): string => {
  const val = getRaw(key);
  if (val === undefined || val === null || val === '') {
    throw new Error(`Missing required environment variable: ${key}. Set it in .env.development or .env.production`);
  }
  return val;
};

/** Get optional env var - returns '' if missing. */
export const getEnvVarOptional = (key: string): string => {
  const val = getRaw(key);
  return val !== undefined && val !== null ? String(val) : '';
};

/**
 * Get backend API URL, upgrading HTTP to HTTPS when page is served over HTTPS.
 * Prevents mixed content blocking when admin is on https:// but backend URL was set as http://.
 */
export const getBackendApiUrl = (): string => {
  const url = getEnvVar('VITE_BACKEND_API_URL');
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && url.startsWith('http://')) {
    return url.replace(/^http:\/\//, 'https://');
  }
  return url;
};
